<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Highlights
        <small>Products sorted by favorite, popular and trending</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Dashboard</a></li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-body" style="overflow: unset;">

          <vue-tabs :start-index="1"
            active-tab-color="#fda229"
            active-text-color="#fff"
            direction="horizontal">

            <v-tab title="Eksplorasi Terfavorit">
              <div class="v-tabs-content">
                <div class="row">
                  <div class="col-sm-12">
                    <h3>Eksplorasi Terfavorit</h3>

                    <div class="alert alert-danger"
                      v-if="error.favorite">
                      <a class="close"
                        @click="error.favorite = false">
                        &times;
                      </a>
                      {{ error.favorite }}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-horizontal">
                      <div class="form-group">
                        <label for="start_date"
                          class="col-sm-2 control-label">
                          Start Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="start_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledStartDatefavorite"
                            :clear-button="true"
                            v-model="form.favorite.start_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="end_date"
                          class="col-sm-2 control-label">
                          End Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="end_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledEndDatefavorite"
                            :clear-button="true"
                            v-model="form.favorite.end_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Status <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Status"
                            class="form-control"
                            id="status"
                            v-model="form.favorite.status">
                            <option value=1>Active</option>
                            <option value=0>Inactive</option>
                          </select>
                        </div>
                      </div>

                      <!-- <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Sequence <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-sequence-aktivitas"
                            name="highlights-sequence-aktivitas"
                            placeholder="Sequence"
                            maxlength="30"
                            v-model="form.favorite.sequence" />
                        </div>
                      </div> -->

                      <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Section Style <span class="req">*</span>
                        </label>
                        <div class="col-md-10">
                          <div class="styleSection">
                            <div class="col-md-6">
                              <label for="Section Style 1">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleFavorite"
                                  value=1
                                  v-model="form.favorite.sectionStyle">
                                  Section Style 1
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle1.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleFavorite"
                                  value=2
                                  v-model="form.favorite.sectionStyle">
                                  Section Style 2
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle2.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 3">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleFavortie"
                                  value=3
                                  v-model="form.favorite.sectionStyle">
                                  Section Style 3
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle3.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 4">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleFavorite"
                                  value=4
                                  v-model="form.favorite.sectionStyle">
                                  Section Style 4
                                  <img
                                  v-if="form.favorite.item_type === 'item'"
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle4.png"
                                  alt="No image"/>
                                  <img
                                  v-else
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle4-chips.png"
                                  alt="No image"/>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-aktivitas"
                          class="control-label col-md-2">
                          Title <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-aktivitas"
                            name="highlights-title-aktivitas"
                            placeholder="Eksplorasi Terfavorit"
                            maxlength="30"
                            v-model="form.favorite.title" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-aktivitas"
                          class="control-label col-md-2">
                          Title En <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-aktivitas"
                            name="highlights-title-aktivitas"
                            placeholder="Eksplorasi Terfavorit"
                            maxlength="30"
                            v-model="form.favorite.title_en" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Eksplorasi Terfavorit"
                            maxlength="90"
                            v-model="form.favorite.description" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description En<span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Eksplorasi Terfavorit"
                            maxlength="90"
                            v-model="form.favorite.description_en" />
                        </div>
                      </div>

                      <div v-if="form.favorite.sectionStyle == 4" class="form-group">
                        <label for="image"
                          class="col-md-2 control-label">
                          Image Campaign <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <button class="btn btn-sm btn-secondary"
                            @click.prevent="showModal('gallery')">
                            Choose File
                          </button>
                          <div class="upload-attention">
                            <h4>Upload Attention</h4>
                            <p>
                              Allowed   extension only for PNG / JPG
                            </p>
                          </div>
                          <img v-if="form.favorite.image.url"
                            class="img-thumbnail img-responsive"
                            alt="Destination Image"
                            :src="parseImage(form.favorite.image.url)">

                          <img v-else
                            class="img-thumbnail img-responsive"
                            src="/static/img/img_placeholder.png"
                            alt="No image">
                        </div>
                      </div>

                      <div v-if="form.favorite.sectionStyle == 4" class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Item Type <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Item Type"
                            class="form-control"
                            id="status"
                            @change="changelist('favorite')"
                            v-model="form.favorite.item_type">
                            <option value="item">Per-Item</option>
                            <option value="category">Category</option>
                            <option value="domestic">Domestic Destination</option>
                            <option value="international">International Destination</option>
                          </select>
                        </div>
                      </div>
                      <div v-if="form.favorite.sectionStyle == 4" class="row">
                        <label for="favorite"
                          class="control-label col-md-2 form-horizontal">
                          items <span class="req">*</span>
                        </label>
                        <div v-if="form.favorite.item_type === 'item'" class="col-md-10 styleSingleItems">
                          <div class="col-md-12">
                            <v-select multiple
                              name="favorite"
                              placeholder="Select favorite highlights"
                              v-model="form.favorite.items"
                              :options="lists.products">
                            </v-select>
                          </div>
                        </div>
                        <div v-if="form.favorite.item_type === 'category'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemCategory, index) in form.favorite.category_items" :key="`${index} + favorite`" class="row">
                              <div class="form-group">
                                <label for="favorite"
                                  class="control-label col-md-2">
                                  Category <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8">
                                  <v-select
                                    name="categories"
                                    placeholder="Select favorite category"
                                    :clearable="false"
                                    v-model="itemCategory.category_id"
                                    @input="onSelectCategories(index, 'favorite')"
                                    :options="lists.categories">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.favorite.category_items.length < 8"
                                    @click.prevent="addItem('favorite', 'categories')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('categories', 'favorite', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="favorite"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="favorite"
                                    placeholder="Select favorite highlights"
                                    v-model="itemCategory.items"
                                    @search:focus="onSelectCategories(index, 'favorite', true)"
                                    :options="lists.categoriesProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="form.favorite.item_type === 'domestic'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemDomestic, index) in form.favorite.destination_items" :key="`${index} + favorite`" class="row">
                              <div class="form-group">
                                <label for="favorite"
                                  class="control-label col-md-2">
                                  Destination <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8" @click="onSelectDestination(index, 'favorite')">
                                  <v-select
                                    name="destination"
                                    placeholder="Input Destination"
                                    v-model="itemDomestic.destination_id"
                                    :clearable="false"
                                    @input="onSelectDomestic(index, 'favorite')"
                                    :options="lists.destinations">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.favorite.destination_items.length < 8"
                                    @click.prevent="addItem('favorite', 'destination')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('destination', 'favorite', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="favorite"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="favorite"
                                    placeholder="Select favorite highlights"
                                    v-model="itemDomestic.items"
                                    @search:focus="onSelectDomestic(index, 'favorite', true)"
                                    :options="lists.domesticProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="form.favorite.item_type === 'international'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemInternational, index) in form.favorite.destination_items" :key="`${index} + favorite`" class="row">
                              <div class="form-group">
                                <label for="favorite"
                                  class="control-label col-md-2">
                                  Destination <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8" @click="onSelectDestination(index, 'favorite')">
                                  <v-select
                                    name="destination"
                                    placeholder="Input Destination"
                                    v-model="itemInternational.destination_id"
                                    :clearable="false"
                                    @input="onSelectInternational(index, 'favorite')"
                                    :options="lists.destinations">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.favorite.destination_items.length < 8"
                                    @click.prevent="addItem('favorite', 'destination')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('destination', 'favorite', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="favorite"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="favorite"
                                    placeholder="Select favorite highlights"
                                    v-model="itemInternational.items"
                                    @search:focus="onSelectInternational(index, 'favorite', true)"
                                    :options="lists.internationalProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="form-group">
                        <label for="favorite"
                          class="control-label col-md-2">
                          Items <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <v-select multiple
                            name="favorite"
                            placeholder="Select favorite highlights"
                            v-model="form.favorite.items"
                            @input="onSelectperItem('favorite')"
                            :options="lists.products">
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2" style="float: right;">
                    <button
                      @click="submit('favorite')"
                      class="btn btn-info btn-block">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <transition name="slideDown">
                <modal title="Select Badge Image"
                  v-if="show.gallery">
                  <FileGallery
                    type="favorite"
                    @update-images="setImage"
                    :selected="form.favorite.image" />
                </modal>
              </transition>
            </v-tab>

            <v-tab title="Rekomendasi Tour">
              <div class="v-tabs-content">
                <div class="row">
                  <div class="col-sm-12">
                    <h3>Rekomendasi Tour</h3>

                    <div class="alert alert-danger"
                      v-if="error.tour">
                      <a class="close"
                        @click="error.tour = false">
                        &times;
                      </a>
                      {{ error.tour }}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-horizontal">
                      <div class="form-group">
                        <label for="start_date"
                          class="col-sm-2 control-label">
                          Start Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="start_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledStartDatetour"
                            :clear-button="true"
                            v-model="form.tour.start_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="end_date"
                          class="col-sm-2 control-label">
                          End Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="end_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledEndDatetour"
                            :clear-button="true"
                            v-model="form.tour.end_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Status <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Status"
                            class="form-control"
                            id="status"
                            v-model="form.tour.status">
                            <option value=1>Active</option>
                            <option value=0>Inactive</option>
                          </select>
                        </div>
                      </div>

                      <!-- <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Sequence <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-sequence-aktivitas"
                            name="highlights-sequence-aktivitas"
                            placeholder="Eksplorasi Terfavorit"
                            maxlength="30"
                            v-model="form.tour.sequence" />
                        </div>
                      </div> -->

                      <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Section Style <span class="req">*</span>
                        </label>
                        <div class="col-md-10">
                          <div class="styleSection">
                            <div class="col-md-6">
                              <label for="Section Style 1">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleTour"
                                  value=1
                                  v-model="form.tour.sectionStyle">
                                  Section Style 1
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle1.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleTour"
                                  value=2
                                  v-model="form.tour.sectionStyle">
                                  Section Style 2
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle2.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 3">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleTour"
                                  value=3
                                  v-model="form.tour.sectionStyle">
                                  Section Style 3
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle3.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 4">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleTour"
                                  value=4
                                  v-model="form.tour.sectionStyle">
                                  Section Style 4
                                  <img
                                  v-if="form.tour.item_type === 'item'"
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle4.png"
                                  alt="No image"/>
                                  <img
                                  v-else
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle4-chips.png"
                                  alt="No image"/>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-aktivitas"
                          class="control-label col-md-2">
                          Title <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-aktivitas"
                            name="highlights-title-aktivitas"
                            placeholder="Rekomendasi Tour"
                            maxlength="30"
                            v-model="form.tour.title" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-aktivitas"
                          class="control-label col-md-2">
                          Title En <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-aktivitas"
                            name="highlights-title-aktivitas"
                            placeholder="Rekomendasi Tour"
                            maxlength="30"
                            v-model="form.tour.title_en" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Rekomendasi Tour"
                            maxlength="90"
                            v-model="form.tour.description" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description En<span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Rekomendasi Tour"
                            maxlength="90"
                            v-model="form.tour.description_en" />
                        </div>
                      </div>

                      <div v-if="form.tour.sectionStyle == 4" class="form-group">
                        <label for="image"
                          class="col-md-2 control-label">
                          Image Campaign <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <button class="btn btn-sm btn-secondary"
                            @click.prevent="showModal('gallery')">
                            Choose File
                          </button>
                          <div class="upload-attention">
                            <h4>Upload Attention</h4>
                            <p>
                              Allowed   extension only for PNG / JPG
                            </p>
                          </div>
                          <img v-if="form.tour.image.url"
                            class="img-thumbnail img-responsive"
                            alt="Destination Image"
                            :src="parseImage(form.tour.image.url)">

                          <img v-else
                            class="img-thumbnail img-responsive"
                            src="/static/img/img_placeholder.png"
                            alt="No image">
                        </div>
                      </div>
                      <div v-if="form.tour.sectionStyle == 4" class="form-group">
                        <label for="type"
                          class="col-sm-2 control-label">
                          Item Type <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select type"
                            class="form-control"
                            id="typetour"
                            @change="changelist('tour')"
                            v-model="form.tour.item_type">
                            <option value='item'>Per-Item</option>
                            <option value='category'>Category</option>
                            <option value='domestic'>Domestic Destination</option>
                            <option value='international'>International Destination</option>
                          </select>
                        </div>
                      </div>
                      <div v-if="form.tour.sectionStyle == 4" class="row">
                        <label for="tour"
                          class="control-label col-md-2 form-horizontal">
                          items <span class="req">*</span>
                        </label>
                        <div v-if="form.tour.item_type === 'item'" class="col-md-10 styleSingleItems">
                          <div class="col-md-12">
                            <v-select multiple
                              name="tour"
                              placeholder="Select tour highlights"
                              v-model="form.tour.items"
                              :options="lists.productsTour">
                            </v-select>
                          </div>
                        </div>
                        <div v-if="form.tour.item_type === 'category'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemCategory, index) in form.tour.category_items" :key="`${index} + tour`" class="row">
                              <div class="form-group">
                                <label for="tour"
                                  class="control-label col-md-2">
                                  Category <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8">
                                  <v-select
                                    name="categories"
                                    placeholder="Select tour category"
                                    :clearable="false"
                                    v-model="itemCategory.category_id"
                                    @input="onSelectCategories(index, 'tour')"
                                    :options="lists.categories">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.tour.category_items.length < 8"
                                    @click.prevent="addItem('tour', 'categories')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('categories', 'tour', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="tour"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="tour"
                                    placeholder="Select tour highlights"
                                    v-model="itemCategory.items"
                                    @search:focus="onSelectCategories(index, 'tour', true)"
                                    :options="lists.categoriesProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="form.tour.item_type === 'domestic'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemDomestic, index) in form.tour.destination_items" :key="`${index} + tour`" class="row">
                              <div class="form-group">
                                <label for="tour"
                                  class="control-label col-md-2">
                                  Destination <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8" @click="onSelectDestination(index, 'tour')">
                                  <v-select
                                    name="destination"
                                    placeholder="Input Destination"
                                    v-model="itemDomestic.destination_id"
                                    :clearable="false"
                                    @input="onSelectDomestic(index, 'tour')"
                                    :options="lists.destinations">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.tour.destination_items.length < 8"
                                    @click.prevent="addItem('tour', 'destination')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('destination', 'tour', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="tour"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="tour"
                                    placeholder="Select tour highlights"
                                    v-model="itemDomestic.items"
                                    @search:focus="onSelectDomestic(index, 'tour', true)"
                                    :options="lists.domesticProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="form.tour.item_type === 'international'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemInternational, index) in form.tour.destination_items" :key="`${index} + tour`" class="row">
                              <div class="form-group">
                                <label for="tour"
                                  class="control-label col-md-2">
                                  Destination <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8" @click="onSelectDestination(index, 'tour')">
                                  <v-select
                                    name="destination"
                                    placeholder="Input Destination"
                                    v-model="itemInternational.destination_id"
                                    :clearable="false"
                                    @input="onSelectInternational(index, 'tour')"
                                    :options="lists.destinations">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.tour.destination_items.length < 8"
                                    @click.prevent="addItem('tour', 'destination')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('destination', 'tour', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="tour"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="tour"
                                    placeholder="Select tour highlights"
                                    v-model="itemInternational.items"
                                    @search:focus="onSelectInternational(index, 'tour', true)"
                                    :options="lists.internationalProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="form-group">
                        <label for="tour"
                          class="control-label col-md-2">
                          Items <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <v-select multiple
                            name="tour"
                            placeholder="Select Rekomendasi Tour highlights"
                            v-model="form.tour.items"
                            @input="onSelectperItem('tour')"
                            :options="lists.productsTour">
                          </v-select>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="col-md-2" style="float: right;">
                    <button
                      @click="submit('tour')"
                      class="btn btn-info btn-block">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <transition name="slideDown">
                <modal title="Select Badge Image"
                  v-if="show.gallery">
                  <FileGallery
                    type="tour"
                    @update-images="setImage"
                    :selected="form.tour.image" />
                </modal>
              </transition>
            </v-tab>

            <v-tab title="Category Populer">
              <div class="v-tabs-content">
                <div class="row">
                  <div class="col-sm-12">
                    <h3>Category Populer</h3>

                    <div class="alert alert-danger"
                      v-if="error.category">
                      <a class="close"
                        @click="error.category = false">
                        &times;
                      </a>
                      {{ error.category }}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-horizontal">
                      <div class="form-group">
                        <label for="start_date"
                          class="col-sm-2 control-label">
                          Start Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="start_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledStartDatecategory"
                            :clear-button="true"
                            v-model="form.category.start_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="end_date"
                          class="col-sm-2 control-label">
                          End Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="end_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledEndDatecategory"
                            :clear-button="true"
                            v-model="form.category.end_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Status <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Status"
                            class="form-control"
                            id="status"
                            v-model="form.category.status">
                            <option value=1>Active</option>
                            <option value=0>Inactive</option>
                          </select>
                        </div>
                      </div>

                      <!-- <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Sequence <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-sequence-aktivitas"
                            name="highlights-sequence-aktivitas"
                            placeholder="Eksplorasi Terfavorit"
                            maxlength="30"
                            v-model="form.category.sequence" />
                        </div>
                      </div> -->

                      <div class="form-group">
                        <label for="highlights-title-aktivitas"
                          class="control-label col-md-2">
                          Title <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-aktivitas"
                            name="highlights-title-aktivitas"
                            placeholder="Category Populer"
                            maxlength="30"
                            v-model="form.category.title" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-aktivitas"
                          class="control-label col-md-2">
                          Title En <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-aktivitas"
                            name="highlights-title-aktivitas"
                            placeholder="Category Populer"
                            maxlength="30"
                            v-model="form.category.title_en" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Category Populer"
                            maxlength="90"
                            v-model="form.category.description" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description En<span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Category Populer"
                            maxlength="90"
                            v-model="form.category.description_en" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="favorite"
                          class="control-label col-md-2">
                          Items <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <v-select multiple
                            name="favorite"
                            placeholder="Select category populer"
                            v-model="form.category.items"
                            v-on:input="limiterCategory"
                            :options="lists.categories">
                          </v-select>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="col-md-2" style="float: right;">
                    <button
                      @click="submit('category')"
                      class="btn btn-info btn-block">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </v-tab>

            <v-tab title="Destinasi Populer">
              <div class="v-tabs-content">
                <div class="row">
                  <div class="col-sm-12">
                    <h3>Destinasi Populer</h3>

                    <div class="alert alert-danger"
                      v-if="error.destination">
                      <a class="close"
                        @click="error.destination = false">
                        &times;
                      </a>
                      {{ error.destination }}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-horizontal">
                      <!-- <div class="form-group">
                        <label for="start_date"
                          class="col-sm-2 control-label">
                          Start Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="start_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledStartDatedestination"
                            :clear-button="true"
                            v-model="form.destination.start_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="end_date"
                          class="col-sm-2 control-label">
                          End Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="end_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledEndDatedestination"
                            :clear-button="true"
                            v-model="form.destination.end_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Status <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Status"
                            class="form-control"
                            id="status"
                            v-model="form.destination.status">
                            <option value=1>Active</option>
                            <option value=0>Inactive</option>
                          </select>
                        </div>
                      </div> -->

                      <div class="form-group">
                        <label for="highlights-title-destinasi"
                          class="control-label col-md-2">
                          Title <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-destinasi"
                            name="highlights-title-destinasi"
                            placeholder="Destinasi Populer"
                            maxlength="30"
                            v-model="form.destination.title" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-destinasi"
                          class="control-label col-md-2">
                          Title En <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-destinasi"
                            name="highlights-title-destinasi"
                            placeholder="Destinasi Populer"
                            maxlength="30"
                            v-model="form.destination.title_en" />
                        </div>
                      </div>

                      <!-- <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Destinasi Populer"
                            maxlength="90"
                            v-model="form.destination.description" />
                        </div>
                      </div> -->
                      <section class="content">
                        <div class="box">
                          <div class="box-body" style="overflow: unset;">
                            <vue-tabs :start-index="1"
                              active-tab-color="#fda229"
                              active-text-color="#fff"
                              @tab-change="onClick"
                              direction="horizontal">
                              <v-tab title="Domestic Destination">
                                <div class="v-tabs-content">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <div class="form-horizontal">
                                        <div class="form-group">
                                          <label for="country"
                                            class="control-label col-md-2">
                                            Country <span class="req">*</span>
                                          </label>

                                          <div class="col-md-10">
                                            <v-select
                                              name="country"
                                              disabled
                                              placeholder="Input Country (Indonesia)"
                                              v-model="form.destination.country_domestic"
                                              :options="lists.destinations">
                                            </v-select>
                                          </div>
                                        </div>
                                        <div class="form-group">
                                          <label for="city"
                                            class="control-label col-md-2">
                                            City/Province <span class="req">*</span>
                                          </label>

                                          <div class="col-md-10">
                                            <v-select multiple
                                              name="city"
                                              placeholder="Input multiple City and Province in Indonesia"
                                              v-model="form.destination.city_domestic"
                                              v-on:input="limiter"
                                              :options="lists.destinations">
                                            </v-select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </v-tab>
                              <v-tab title="International Destination">
                                <div class="v-tabs-content">
                                  <div class="row"
                                  v-for="(item, index) in form.destination.international"
                                  :key="index">
                                    <div class="col-md-12">
                                      <div class="form-horizontal">
                                        <div class="form-group">
                                          <label for="country"
                                            class="control-label col-md-2">
                                            Country <span class="req">*</span>
                                          </label>

                                          <div class="col-md-8" @click="onSelectDestination(index, 'destination')">
                                            <v-select
                                              name="country"
                                              placeholder="Input Country"
                                              v-model="form.destination.international[index].country_international"
                                              @input="onSelectCountry(index)"
                                              :options="lists.destinations">
                                            </v-select>
                                          </div>
                                        <div class="col-md-2">
                                          <button class="btn btn-info btn-xs"
                                            v-if="form.destination.international.length < 4"
                                            @click.prevent="addItem('international')">
                                            <i class="fa fa-plus"></i>
                                          </button>
                                          <button class="btn btn-danger btn-xs"
                                            v-if="index > 0"
                                            @click.prevent="removeItem(item, 'international', index)">
                                            <i class="fa fa-minus"></i>
                                          </button>
                                        </div>
                                        </div>
                                        <div class="form-group">
                                          <label for="city"
                                            class="control-label col-md-2">
                                            City <span class="req">*</span>
                                          </label>

                                          <div class="col-md-8">
                                            <v-select multiple
                                              name="city"
                                              placeholder="Input multiple City in This Country"
                                              v-model="form.destination.international[index].city_international"
                                              :options="lists.cities"
                                              v-on:input="limiter"
                                              @search:focus="setSelected(index)"
                                              >
                                            </v-select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </v-tab>
                            </vue-tabs>
                          </div>
                        </div>
                      </section>

                      <!-- <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description En<span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Destinasi Populer"
                            maxlength="90"
                            v-model="form.destination.description_en" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="favorite"
                          class="control-label col-md-2">
                          Items <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <v-select multiple
                            name="favorite"
                            placeholder="Select destination highlights"
                            v-model="form.destination.items"
                            :options="lists.destinations">
                          </v-select>
                        </div>
                      </div> -->
                    </div>
                  </div>

                  <div class="col-md-2" style="float: right;">
                    <button
                      @click="submit('destination')"
                      class="btn btn-info btn-block">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </v-tab>

            <v-tab title="Pilihan Bulan Ini">
              <div class="v-tabs-content">
                <div class="row">
                  <div class="col-sm-12">
                    <h3>Pilihan Bulan Ini</h3>

                    <div class="alert alert-danger"
                      v-if="error.favorite">
                      <a class="close"
                        @click="error.favorite = false">
                        &times;
                      </a>
                      {{ error.favorite }}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-horizontal">
                      <div class="form-group">
                        <label for="start_date"
                          class="col-sm-2 control-label">
                          Start Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="start_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledStartDatetrending"
                            :clear-button="true"
                            v-model="form.trending.start_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="end_date"
                          class="col-sm-2 control-label">
                          End Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="end_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledEndDatetrending"
                            :clear-button="true"
                            v-model="form.trending.end_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Status <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Status"
                            class="form-control"
                            id="status"
                            v-model="form.trending.status">
                            <option value=1>Active</option>
                            <option value=0>Inactive</option>
                          </select>
                        </div>
                      </div>

                      <!-- <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Sequence <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-sequence-aktivitas"
                            name="highlights-sequence-aktivitas"
                            placeholder="Eksplorasi Terfavorit"
                            maxlength="30"
                            v-model="form.trending.sequence" />
                        </div>
                      </div> -->

                      <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Section Style <span class="req">*</span>
                        </label>
                        <div class="col-md-10">
                          <div class="styleSection">
                            <div class="col-md-6">
                              <label for="Section Style 1">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleTrending"
                                  value=1
                                  v-model="form.trending.sectionStyle">
                                  Section Style 1
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle1.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleTrending"
                                  value=2
                                  v-model="form.trending.sectionStyle">
                                  Section Style 2
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle2.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 3">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleTrending"
                                  value=3
                                  v-model="form.trending.sectionStyle">
                                  Section Style 3
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle3.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 4">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleTrending"
                                  value=4
                                  v-model="form.trending.sectionStyle">
                                  Section Style 4
                                  <img
                                  v-if="form.trending.item_type === 'item'"
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle4.png"
                                  alt="No image"/>
                                  <img
                                  v-else
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle4-chips.png"
                                  alt="No image"/>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-pilihan"
                          class="control-label col-md-2">
                          Title <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-pilihan"
                            name="highlights-title-pilihan"
                            placeholder="Pilihan Bulan Ini"
                            maxlength="30"
                            v-model="form.trending.title" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-pilihan"
                          class="control-label col-md-2">
                          Title En <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-pilihan"
                            name="highlights-title-pilihan"
                            placeholder="Pilihan Bulan Ini"
                            maxlength="30"
                            v-model="form.trending.title_en" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Pilihan Bulan Ini"
                            maxlength="90"
                            v-model="form.trending.description" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description En<span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Pilihan Bulan Ini"
                            maxlength="90"
                            v-model="form.trending.description_en" />
                        </div>
                      </div>

                      <div v-if="form.trending.sectionStyle == 4" class="form-group">
                        <label for="image"
                          class="col-md-2 control-label">
                          Image Campaign <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <button class="btn btn-sm btn-secondary"
                            @click.prevent="showModal('gallery')">
                            Choose File
                          </button>
                          <div class="upload-attention">
                            <h4>Upload Attention</h4>
                            <p>
                              Allowed   extension only for PNG / JPG
                            </p>
                          </div>
                          <img v-if="form.trending.image.url"
                            class="img-thumbnail img-responsive"
                            alt="Destination Image"
                            :src="parseImage(form.trending.image.url)">

                          <img v-else
                            class="img-thumbnail img-responsive"
                            src="/static/img/img_placeholder.png"
                            alt="No image">
                        </div>
                      </div>

                      <div v-if="form.trending.sectionStyle == 4" class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Item Type <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Item Type"
                            class="form-control"
                            id="status"
                            @change="changelist('trending')"
                            v-model="form.trending.item_type">
                            <option value='item'>Per-Item</option>
                            <option value='category'>Category</option>
                            <option value='domestic'>Domestic Destination</option>
                            <option value='international'>International Destination</option>
                          </select>
                        </div>
                      </div>
                      <div v-if="form.trending.sectionStyle == 4" class="row">
                        <label for="trending"
                          class="control-label col-md-2 form-horizontal">
                          items <span class="req">*</span>
                        </label>
                        <div v-if="form.trending.item_type === 'item'" class="col-md-10 styleSingleItems">
                          <div class="col-md-12">
                            <v-select multiple
                              name="trending"
                              placeholder="Select trending highlights"
                              v-model="form.trending.items"
                              :options="lists.products">
                            </v-select>
                          </div>
                        </div>
                        <div v-if="form.trending.item_type === 'category'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemCategory, index) in form.trending.category_items" :key="`${index} + trending`" class="row">
                              <div class="form-group">
                                <label for="trending"
                                  class="control-label col-md-2">
                                  Category <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8">
                                  <v-select
                                    name="categories"
                                    placeholder="Select trending category"
                                    v-model="itemCategory.category_id"
                                    :clearable="false"
                                    @input="onSelectCategories(index, 'trending')"
                                    :options="lists.categories">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.trending.category_items.length < 8"
                                    @click.prevent="addItem('trending', 'categories')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('categories', 'trending', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="trending"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="trending"
                                    placeholder="Select trending highlights"
                                    v-model="itemCategory.items"
                                    :options="lists.categoriesProducts"
                                    @search:focus="setSelectedCategory(index, 'trending')">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="form.trending.item_type === 'domestic'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemDomestic, index) in form.trending.destination_items" :key="`${index} + trending`" class="row">
                              <div class="form-group">
                                <label for="trending"
                                  class="control-label col-md-2">
                                  Destination <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8" @click="onSelectDestination(index, 'trending')">
                                  <v-select
                                    name="destination"
                                    placeholder="Input Destination"
                                    v-model="itemDomestic.destination_id"
                                    :clearable="false"
                                    @input="onSelectDomestic(index, 'trending')"
                                    :options="lists.destinations">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.trending.destination_items.length < 8"
                                    @click.prevent="addItem('trending', 'destination')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('destination', 'trending', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="trending"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="trending"
                                    placeholder="Select trending highlights"
                                    v-model="itemDomestic.items"
                                    @search:focus="onSelectDomestic(index, 'trending', true)"
                                    :options="lists.domesticProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="form.trending.item_type === 'international'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemInternational, index) in form.trending.destination_items" :key="`${index} + trending`" class="row">
                              <div class="form-group">
                                <label for="trending"
                                  class="control-label col-md-2">
                                  Destination <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8" @click="onSelectDestination(index, 'trending')">
                                  <v-select
                                    name="destination"
                                    placeholder="Input Destination"
                                    v-model="itemInternational.destination_id"
                                    :clearable="false"
                                    @input="onSelectInternational(index, 'trending')"
                                    :options="lists.destinations">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.trending.destination_items.length < 8"
                                    @click.prevent="addItem('trending', 'destination')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('destination', 'trending', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="trending"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="trending"
                                    placeholder="Select trending highlights"
                                    v-model="itemInternational.items"
                                    @search:focus="onSelectInternational(index, 'trending', true)"
                                    :options="lists.internationalProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-else class="form-group">
                        <label for="favorite"
                          class="control-label col-md-2">
                          Items <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <v-select multiple
                            name="favorite"
                            placeholder="Select favorite highlights"
                            v-model="form.trending.items"
                            @input="onSelectperItem('trending')"
                            :options="lists.products">
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <button
                      @click="submit('trending')"
                      class="btn btn-info btn-block">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <transition name="slideDown">
                <modal title="Select Badge Image"
                  v-if="show.gallery">
                  <FileGallery
                    type="trending"
                    @update-images="setImage"
                    :selected="form.trending.image" />
                </modal>
              </transition>
            </v-tab>

            <v-tab title="Campaign 1">
              <div class="v-tabs-content">
                <div class="row">
                  <div class="col-sm-12">
                    <h3>Campaign 1</h3>

                    <div class="alert alert-danger"
                      v-if="error.campaign1">
                      <a class="close"
                        @click="error.campaign1 = false">
                        &times;
                      </a>
                      {{ error.campaign1 }}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-horizontal">
                      <div class="form-group">
                        <label for="start_date"
                          class="col-sm-2 control-label">
                          Start Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="start_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledStartDateCampaign1"
                            :clear-button="true"
                            v-model="form.campaign1.start_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="end_date"
                          class="col-sm-2 control-label">
                          End Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="end_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledEndDateCampaign1"
                            :clear-button="true"
                            v-model="form.campaign1.end_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Status <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Status"
                            class="form-control"
                            id="status"
                            v-model="form.campaign1.status">
                            <option value=1>Active</option>
                            <option value=0>Inactive</option>
                          </select>
                        </div>
                      </div>

                      <!-- <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Sequence <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-sequence-aktivitas"
                            name="highlights-sequence-aktivitas"
                            placeholder="Sequence"
                            maxlength="30"
                            v-model="form.campaign1.sequence" />
                        </div>
                      </div> -->

                      <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Section Style <span class="req">*</span>
                        </label>
                        <div class="col-md-10">
                          <div class="styleSection">
                            <div class="col-md-6">
                              <label for="Section Style 1">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleCampaign1"
                                  value=1
                                  v-model="form.campaign1.sectionStyle">
                                  Section Style 1
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle1.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleCampaign1"
                                  value=2
                                  v-model="form.campaign1.sectionStyle">
                                  Section Style 2
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle2.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 3">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleCampaign1"
                                  value=3
                                  v-model="form.campaign1.sectionStyle">
                                  Section Style 3
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle3.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 4">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleCampaign1"
                                  value=4
                                  v-model="form.campaign1.sectionStyle">
                                  Section Style 4
                                  <img
                                  v-if="form.campaign1.item_type === 'item'"
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle4.png"
                                  alt="No image"/>
                                  <img
                                  v-else
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle4-chips.png"
                                  alt="No image"/>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-aktivitas"
                          class="control-label col-md-2">
                          Title <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-aktivitas"
                            name="highlights-title-aktivitas"
                            placeholder="Eksplorasi Terfavorit"
                            maxlength="30"
                            v-model="form.campaign1.title" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-aktivitas"
                          class="control-label col-md-2">
                          Title En <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-aktivitas"
                            name="highlights-title-aktivitas"
                            placeholder="Eksplorasi Terfavorit"
                            maxlength="30"
                            v-model="form.campaign1.title_en" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Eksplorasi Terfavorit"
                            maxlength="90"
                            v-model="form.campaign1.description" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description En<span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Eksplorasi Terfavorit"
                            maxlength="90"
                            v-model="form.campaign1.description_en" />
                        </div>
                      </div>

                      <div v-if="form.campaign1.sectionStyle == 4" class="form-group">
                        <label for="image"
                          class="col-md-2 control-label">
                          Image Campaign <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <button class="btn btn-sm btn-secondary"
                            @click.prevent="showModal('gallery')">
                            Choose File
                          </button>
                          <div class="upload-attention">
                            <h4>Upload Attention</h4>
                            <p>
                              Allowed   extension only for PNG / JPG
                            </p>
                          </div>
                          <img v-if="form.campaign1.image.url"
                            class="img-thumbnail img-responsive"
                            alt="Destination Image"
                            :src="parseImage(form.campaign1.image.url)">

                          <img v-else
                            class="img-thumbnail img-responsive"
                            src="/static/img/img_placeholder.png"
                            alt="No image">
                        </div>
                      </div>
                      <div v-if="form.campaign1.sectionStyle == 4" class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Item Type <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Item Type"
                            class="form-control"
                            id="status"
                            @change="changelist('campaign1')"
                            v-model="form.campaign1.item_type">
                            <option value='item'>Per-Item</option>
                            <option value='category'>Category</option>
                            <option value='domestic'>Domestic Destination</option>
                            <option value='international'>International Destination</option>
                          </select>
                        </div>
                      </div>
                      <div v-if="form.campaign1.sectionStyle == 4" class="row">
                        <label for="campaign1"
                          class="control-label col-md-2 form-horizontal">
                          items <span class="req">*</span>
                        </label>
                        <div v-if="form.campaign1.item_type === 'item'" class="col-md-10 styleSingleItems">
                          <div class="col-md-12">
                            <v-select multiple
                              name="campaign1"
                              placeholder="Select campaign1 highlights"
                              v-model="form.campaign1.items"
                              :options="lists.products">
                            </v-select>
                          </div>
                        </div>
                        <div v-if="form.campaign1.item_type === 'category'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemCategory, index) in form.campaign1.category_items" :key="`${index} + campaign1`" class="row">
                              <div class="form-group">
                                <label for="campaign1"
                                  class="control-label col-md-2">
                                  Category <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8">
                                  <v-select
                                    name="categories"
                                    placeholder="Select campaign1 category"
                                    :clearable="false"
                                    v-model="itemCategory.category_id"
                                    @input="onSelectCategories(index, 'campaign1')"
                                    :options="lists.categories">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.campaign1.category_items.length < 8"
                                    @click.prevent="addItem('campaign1', 'categories')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('categories', 'campaign1', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="campaign1"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="campaign1"
                                    placeholder="Select campaign1 highlights"
                                    v-model="itemCategory.items"
                                    @search:focus="onSelectCategories(index, 'campaign1', true)"
                                    :options="lists.categoriesProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="form.campaign1.item_type === 'domestic'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemDomestic, index) in form.campaign1.destination_items" :key="`${index} + campaign1`" class="row">
                              <div class="form-group">
                                <label for="campaign1"
                                  class="control-label col-md-2">
                                  Destination <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8" @click="onSelectDestination(index, 'campaign1')">
                                  <v-select
                                    name="destination"
                                    placeholder="Input Destination"
                                    v-model="itemDomestic.destination_id"
                                    :clearable="false"
                                    @input="onSelectDomestic(index, 'campaign1')"
                                    :options="lists.destinations">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.campaign1.destination_items.length < 8"
                                    @click.prevent="addItem('campaign1', 'destination')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('destination', 'campaign1', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="campaign1"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="campaign1"
                                    placeholder="Select campaign1 highlights"
                                    v-model="itemDomestic.items"
                                    @search:focus="onSelectDomestic(index, 'campaign1', true)"
                                    :options="lists.domesticProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="form.campaign1.item_type === 'international'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemInternational, index) in form.campaign1.destination_items" :key="`${index} + campaign1`" class="row">
                              <div class="form-group">
                                <label for="campaign1"
                                  class="control-label col-md-2">
                                  Destination <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8" @click="onSelectDestination(index, 'campaign1')">
                                  <v-select
                                    name="destination"
                                    placeholder="Input Destination"
                                    v-model="itemInternational.destination_id"
                                    :clearable="false"
                                    @input="onSelectInternational(index, 'campaign1')"
                                    :options="lists.destinations">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.campaign1.destination_items.length < 8"
                                    @click.prevent="addItem('campaign1', 'destination')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('destination', 'campaign1', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="campaign1"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="campaign1"
                                    placeholder="Select campaign1 highlights"
                                    v-model="itemInternational.items"
                                    @search:focus="onSelectInternational(index, 'campaign1', true)"
                                    :options="lists.internationalProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="form-group">
                        <label for="campaign"
                          class="control-label col-md-2">
                          Items <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <v-select multiple
                            name="campaign"
                            placeholder="Select Campaign 1 highlights"
                            v-model="form.campaign1.items"
                            @input="onSelectperItem('campaign1')"
                            :options="lists.products">
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2" style="float: right;">
                    <button
                      @click="submit('campaign1')"
                      class="btn btn-info btn-block">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <transition name="slideDown">
                <modal title="Select Badge Image"
                  v-if="show.gallery">
                  <FileGallery
                    type="campaign1"
                    @update-images="setImage"
                    :selected="form.campaign1.image" />
                </modal>
              </transition>
            </v-tab>

            <v-tab title="Campaign 2">
              <div class="v-tabs-content">
                <div class="row">
                  <div class="col-sm-12">
                    <h3>Campaign 2</h3>

                    <div class="alert alert-danger"
                      v-if="error.campaign2">
                      <a class="close"
                        @click="error.campaign2 = false">
                        &times;
                      </a>
                      {{ error.campaign2 }}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-horizontal">
                      <div class="form-group">
                        <label for="start_date"
                          class="col-sm-2 control-label">
                          Start Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="start_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledStartDateCampaign2"
                            :clear-button="true"
                            v-model="form.campaign2.start_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="end_date"
                          class="col-sm-2 control-label">
                          End Date <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <datepicker
                            id="end_date"
                            wrapper-class="custom-vdp"
                            input-class="form-control"
                            :disabled="disabledEndDateCampaign2"
                            :clear-button="true"
                            v-model="form.campaign2.end_date">
                          </datepicker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Status <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Status"
                            class="form-control"
                            id="status"
                            v-model="form.campaign2.status">
                            <option value=1>Active</option>
                            <option value=0>Inactive</option>
                          </select>
                        </div>
                      </div>

                      <!-- <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Sequence <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-sequence-aktivitas"
                            name="highlights-sequence-aktivitas"
                            placeholder="Sequence"
                            maxlength="30"
                            v-model="form.campaign2.sequence" />
                        </div>
                      </div> -->

                      <div class="form-group">
                        <label for="highlights-sequence-aktivitas"
                          class="control-label col-md-2">
                          Section Style <span class="req">*</span>
                        </label>
                        <div class="col-md-10">
                          <div class="styleSection">
                            <div class="col-md-6">
                              <label for="Section Style 1">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleCampaign2"
                                  value=1
                                  v-model="form.campaign2.sectionStyle">
                                  Section Style 1
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle1.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 2">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleCampaign2"
                                  value=2
                                  v-model="form.campaign2.sectionStyle">
                                  Section Style 2
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle2.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 3">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleCampaign2"
                                  value=3
                                  v-model="form.campaign2.sectionStyle">
                                  Section Style 3
                                  <img
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle3.png"
                                  alt="No image"/>
                              </label>
                            </div>
                            <div class="col-md-6">
                              <label for="Section Style 4">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sectionStyleCampaign2"
                                  value=4
                                  v-model="form.campaign2.sectionStyle">
                                  Section Style 4
                                  <img
                                  v-if="form.campaign2.item_type === 'item'"
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle4.png"
                                  alt="No image"/>
                                  <img
                                  v-else
                                  class="imageSectionStyle"
                                  src="/static/img/SectionStyle4-chips.png"
                                  alt="No image"/>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-aktivitas"
                          class="control-label col-md-2">
                          Title <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-aktivitas"
                            name="highlights-title-aktivitas"
                            placeholder="Eksplorasi Terfavorit"
                            maxlength="30"
                            v-model="form.campaign2.title" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-title-aktivitas"
                          class="control-label col-md-2">
                          Title En <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-title-aktivitas"
                            name="highlights-title-aktivitas"
                            placeholder="Eksplorasi Terfavorit"
                            maxlength="30"
                            v-model="form.campaign2.title_en" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Eksplorasi Terfavorit"
                            maxlength="90"
                            v-model="form.campaign2.description" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="highlights-description"
                          class="control-label col-md-2">
                          Description En<span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <input type="text"
                            class="form-control strong"
                            id="highlights-description"
                            name="highlights-description"
                            placeholder="Deskripsi Eksplorasi Terfavorit"
                            maxlength="90"
                            v-model="form.campaign2.description_en" />
                        </div>
                      </div>

                      <div v-if="form.campaign2.sectionStyle == 4" class="form-group">
                        <label for="image"
                          class="col-md-2 control-label">
                          Image Campaign <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <button class="btn btn-sm btn-secondary"
                            @click.prevent="showModal('gallery')">
                            Choose File
                          </button>
                          <div class="upload-attention">
                            <h4>Upload Attention</h4>
                            <p>
                              Allowed   extension only for PNG / JPG
                            </p>
                          </div>
                          <img v-if="form.campaign2.image.url"
                            class="img-thumbnail img-responsive"
                            alt="Destination Image"
                            :src="parseImage(form.campaign2.image.url)">

                          <img v-else
                            class="img-thumbnail img-responsive"
                            src="/static/img/img_placeholder.png"
                            alt="No image">
                        </div>
                      </div>
                      <div v-if="form.campaign2.sectionStyle == 4" class="form-group">
                        <label for="status"
                          class="col-sm-2 control-label">
                          Item Type <span class="req">*</span>
                        </label>

                        <div class="col-sm-10">
                          <select
                            placeholder="Select Item Type"
                            class="form-control"
                            id="status"
                            @change="changelist('campaign2')"
                            v-model="form.campaign2.item_type">
                            <option value='item'>Per-Item</option>
                            <option value='category'>Category</option>
                            <option value='domestic'>Domestic Destination</option>
                            <option value='international'>International Destination</option>
                          </select>
                        </div>
                      </div>
                      <div v-if="form.campaign2.sectionStyle == 4" class="row">
                        <label for="campaign2"
                          class="control-label col-md-2 form-horizontal">
                          items <span class="req">*</span>
                        </label>
                        <div v-if="form.campaign2.item_type === 'item'" class="col-md-10 styleSingleItems">
                          <div class="col-md-12">
                            <v-select multiple
                              name="campaign2"
                              placeholder="Select campaign2 highlights"
                              v-model="form.campaign2.items"
                              :options="lists.products">
                            </v-select>
                          </div>
                        </div>
                        <div v-if="form.campaign2.item_type === 'category'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemCategory, index) in form.campaign2.category_items" :key="`${index} + campaign2`" class="row">
                              <div class="form-group">
                                <label for="campaign2"
                                  class="control-label col-md-2">
                                  Category <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8">
                                  <v-select
                                    name="categories"
                                    placeholder="Select campaign2 category"
                                    :clearable="false"
                                    v-model="itemCategory.category_id"
                                    @input="onSelectCategories(index, 'campaign2')"
                                    :options="lists.categories">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.campaign2.category_items.length < 8"
                                    @click.prevent="addItem('campaign2', 'categories')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('categories', 'campaign2', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="campaign2"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="campaign2"
                                    placeholder="Select campaign2 highlights"
                                    v-model="itemCategory.items"
                                    @search:focus="onSelectCategories(index, 'campaign2', true)"
                                    :options="lists.categoriesProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="form.campaign2.item_type === 'domestic'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemDomestic, index) in form.campaign2.destination_items" :key="`${index} + campaign2`" class="row">
                              <div class="form-group">
                                <label for="campaign2"
                                  class="control-label col-md-2">
                                  Destination <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8" @click="onSelectDestination(index, 'campaign2')">
                                  <v-select
                                    name="destination"
                                    placeholder="Input Destination"
                                    v-model="itemDomestic.destination_id"
                                    :clearable="false"
                                    @input="onSelectDomestic(index, 'campaign2')"
                                    :options="lists.destinations">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.campaign2.destination_items.length < 8"
                                    @click.prevent="addItem('campaign2', 'destination')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('destination', 'campaign2', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="campaign2"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="campaign2"
                                    placeholder="Select campaign2 highlights"
                                    v-model="itemDomestic.items"
                                    @search:focus="onSelectDomestic(index, 'campaign2', true)"
                                    :options="lists.domesticProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="form.campaign2.item_type === 'international'" class="col-md-10">
                          <div class="styleItems">
                            <div v-for="(itemInternational, index) in form.campaign2.destination_items" :key="`${index} + campaign2`" class="row">
                              <div class="form-group">
                                <label for="campaign2"
                                  class="control-label col-md-2">
                                  Destination <span class="req">*</span>
                                </label>
                                
                                <div class="col-md-8" @click="onSelectDestination(index, 'campaign2')">
                                  <v-select
                                    name="destination"
                                    placeholder="Input Destination"
                                    v-model="itemInternational.destination_id"
                                    :clearable="false"
                                    @input="onSelectInternational(index, 'campaign2')"
                                    :options="lists.destinations">
                                  </v-select>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    v-if="form.campaign2.destination_items.length < 8"
                                    @click.prevent="addItem('campaign2', 'destination')">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="index > 0"
                                    @click.prevent="removeItem('destination', 'campaign2', index)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
        
                              <div class="form-group">
                                <label for="campaign2"
                                  class="control-label col-md-2">
                                  Items <span class="req">*</span>
                                </label>
        
                                <div class="col-md-8">
                                  <v-select multiple
                                    name="campaign2"
                                    placeholder="Select campaign2 highlights"
                                    v-model="itemInternational.items"
                                    @search:focus="onSelectInternational(index, 'campaign2', true)"
                                    :options="lists.internationalProducts">
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="form-group">
                        <label for="campaign"
                          class="control-label col-md-2">
                          Items <span class="req">*</span>
                        </label>

                        <div class="col-md-10">
                          <v-select multiple
                            name="campaign"
                            placeholder="Select Campaign 2 highlights"
                            v-model="form.campaign2.items"
                            @input="onSelectperItem('campaign2')"
                            :options="lists.products">
                          </v-select>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="col-md-2" style="float: right;">
                    <button
                      @click="submit('campaign2')"
                      class="btn btn-info btn-block">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <transition name="slideDown">
                <modal title="Select Badge Image"
                  v-if="show.gallery">
                  <FileGallery
                    type="campaign2"
                    @update-images="setImage"
                    :selected="form.campaign2.image" />
                </modal>
              </transition>
            </v-tab>

            <v-tab title="Sequence">
              <div class="v-tabs-content">
                <div class="row">
                  <div class="col-md-6">
                    <h3>Sequence for Section</h3>
                    <draggable
                      :list="lists.sequenceList"
                      :disabled="false"
                      class="list-group"
                      animation=200
                      ghost-class="ghost"
                      @start="dragging = true"
                      @end="dragging = false"
                    >
                      <transition-group type="transition" :name="!dragging ? 'flip-list' : null">
                        <div
                          class="list-group-item listSequence"
                          v-for="element in lists.sequenceList"
                          :key="element.id"
                        >
                          {{ element.title }}
                        </div>
                      </transition-group>
                    </draggable>
                  </div>
                  <div class="col-md-2" style="float: right; margin-top: 55px;">
                    <button
                      @click="submit('sequence')"
                      class="btn btn-info btn-block">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </v-tab>

          </vue-tabs>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import flatten from 'lodash/flatten';
import FileGallery from '@/components/modules/common/FileGallery';
import Common from '@/mixins/Common';
import Datepicker from 'vuejs-datepicker';
import Modal from '@/components/modules/common/Modal';
import draggable from 'vuedraggable';
import { VueTabs, VTab } from 'vue-nav-tabs';
import 'vue-nav-tabs/themes/vue-tabs.css';

export default {
  name: 'HighlightsForm',

  mixins: [Common],
  data() {
    return {
      title: 'Highlights',
      
      dragging: true,

      error: {
        destination: null,
        trending: null,
        tour: null,
        campaign1: null,
        campaign2: null,
        favorite: null,
        category: null,
        product: null,
      },

      isLoading: true,
      show: {
        gallery: false,
      },
      form: {
        trending: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null,
          },
          sectionStyle: 0,
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          item_type: null,
          items: [],
          category_items: [{
            category_id: null,
            items: [],
          }],
          destination_items: [{
            destination_id: null,
            items: [],
          }],
        },

        tour: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null,
          },
          sectionStyle: 0,
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          item_type: null,
          items: [],
          category_items: [{
            category_id: null,
            items: [],
          }],
          destination_items: [{
            destination_id: null,
            items: [],
          }],
        },

        campaign1: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null,
          },
          sectionStyle: 0,
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          item_type: null,
          items: [],
          category_items: [{
            category_id: null,
            items: [],
          }],
          destination_items: [{
            destination_id: null,
            items: [],
          }],
        },

        campaign2: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null,
          },
          sectionStyle: 0,
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          item_type: null,
          items: [],
          category_items: [{
            category_id: null,
            items: [],
          }],
          destination_items: [{
            destination_id: null,
            items: [],
          }],
        },

        destination: {
          title: null,
          title_en: null,
          image: {
            id: null,
            url: null,
          },
          description: null,
          description_en: null,
          country_domestic: [{
            label: 'Indonesia',
            value: 115,
          }],
          city_domestic: [],
          international: [{
            country_international: [],
            city_international: [],
          }],
          items: [],
        },

        favorite: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null,
          },
          sectionStyle: 0,
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          item_type: null,
          items: [],
          category_items: [{
            category_id: null,
            items: [],
          }],
          destination_items: [{
            destination_id: null,
            items: [],
          }],
        },

        category: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null,
          },
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          items: [],
        },
      },

      lists: {
        cities: [],
        destinations: [],
        internationalDestinations: [],
        products: [],
        categories: [],
        productsTour: [],
        categoriesProducts: [],
        domesticProducts: [],
        internationalProducts: [],
        sequenceList: [],
      },

      tabDestination: 0,
    };
  },

  components: {
    VueTabs,
    VTab,
    Datepicker,
    Modal,
    FileGallery,
    draggable,
  },
  computed: {
    disabledStartDateCampaign1() {
      return {
        to: (this.form.campaign1.start_date)
        ? moment().subtract(1, 'days').toDate()
        : moment().subtract(1, 'days').toDate(),
        from: this.form.campaign1.end_date ? moment(this.form.campaign1.end_date).toDate() : null,
      };
    },
    disabledEndDateCampaign1() {
      return {
        to: (this.form.campaign1.start_date)
        ? moment(this.form.campaign1.start_date).toDate()
        : moment().toDate(),
      };
    },
    disabledStartDateCampaign2() {
      return {
        to: (this.form.campaign2.start_date)
        ? moment().subtract(1, 'days').toDate()
        : moment().subtract(1, 'days').toDate(),
        from: this.form.campaign2.end_date ? moment(this.form.campaign2.end_date).toDate() : null,
      };
    },
    disabledEndDateCampaign2() {
      return {
        to: (this.form.campaign2.start_date)
        ? moment(this.form.campaign2.start_date).toDate()
        : moment().toDate(),
      };
    },
    disabledStartDatefavorite() {
      return {
        to: (this.form.favorite.start_date)
        ? moment().subtract(1, 'days').toDate()
        : moment().subtract(1, 'days').toDate(),
        from: this.form.favorite.end_date ? moment(this.form.favorite.end_date).toDate() : null,
      };
    },
    disabledEndDatefavorite() {
      return {
        to: (this.form.favorite.start_date)
        ? moment(this.form.favorite.start_date).toDate()
        : moment().toDate(),
      };
    },
    disabledStartDatetour() {
      return {
        to: (this.form.tour.start_date)
        ? moment().subtract(1, 'days').toDate()
        : moment().subtract(1, 'days').toDate(),
        from: this.form.tour.end_date ? moment(this.form.tour.end_date).toDate() : null,
      };
    },
    disabledEndDatetour() {
      return {
        to: (this.form.tour.start_date)
        ? moment(this.form.tour.start_date).toDate()
        : moment().toDate(),
      };
    },
    disabledStartDatecategory() {
      return {
        to: (this.form.category.start_date)
        ? moment().subtract(1, 'days').toDate()
        : moment().subtract(1, 'days').toDate(),
        from: this.form.category.end_date ? moment(this.form.category.end_date).toDate() : null,
      };
    },
    disabledEndDatecategory() {
      return {
        to: (this.form.category.start_date)
        ? moment(this.form.category.start_date).toDate()
        : moment().toDate(),
      };
    },
    disabledStartDatetrending() {
      return {
        to: (this.form.trending.start_date)
        ? moment().subtract(1, 'days').toDate()
        : moment().subtract(1, 'days').toDate(),
        from: this.form.trending.end_date ? moment(this.form.trending.end_date).toDate() : null,
      };
    },
    disabledEndDatetrending() {
      return {
        to: (this.form.trending.start_date)
        ? moment(this.form.trending.start_date).toDate()
        : moment().toDate(),
      };
    },
    draggingInfo() {
      return this.dragging ? 'under drag' : '';
    },
  },
  methods: {
    limiter(e) {
      if (e.length > 8) {
        e.pop();
        this.$swal('Limited Input City', 'Max of items selected is 8', 'warning');
      }
    },
    limiterCategory(e) {
      if (e.length > 8) {
        e.pop();
        this.$swal('Limited Input Category', 'Max of items selected is 8', 'warning');
      }
    },
    setSelected(val) {
      this.onSelectCountry(val, true);
    },
    setSelectedCategory(val, type) {
      this.onSelectCategories(val, type, true);
    },
    showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    setImage(payload) {
      this.form[payload.target].image = payload.images;
    },
    fetchHighlight(type) {
      this.error[type] = null;

      return new Promise((resolve, reject) => {
        if (type === 'campaign1' || type === 'campaign2') {
          this.axios.get(`/highlights/campaign/${type}`)
        .then((response) => {
          const { data } = response.data;
          this.form[type].start_date = data.start_date;
          this.form[type].end_date = data.end_date;
          this.form[type].status = data.status;
          // this.form[type].sequence = data.sequence;
          this.form[type].item_type = data.item_type;
          this.form[type].image.url = data.image || '';
          this.form[type].sectionStyle = data.style;
          this.form[type].title = data.title;
          this.form[type].title_en = data.title_en;
          this.form[type].description = data.description;
          this.form[type].description_en = data.description_en;
          if (data.destination_items !== null && data.destination_items.length > 0) {
            this.form[type].destination_items = data.destination_items.map(item => ({
              destination_id: {
                value: item.id,
                label: item.name,
              },
              items: item.items.map(val => ({
                value: val.id,
                label: val.name,
              })),
            }));
          }
          if (data.category_items !== null && data.category_items.length > 0) {
            this.form[type].category_items = data.category_items.map(item => ({
              category_id: {
                value: item.id,
                label: item.name,
              },
              items: item.items.map(val => ({
                value: val.id,
                label: val.name,
              })),
            }));
          }
          if (data.items !== null && data.items.length > 0) {
            this.form[type].items = data.items.map(item => ({
              value: item.id,
              label: item.name,
            }));
          }
          resolve();
        })
        .catch((error) => {
          console.log(`${type} error`, error);

          if (error.response) {
            this.error = error.response.data.errors;
            reject();
          }
        });
        } else {
          this.axios.get(`/highlights/${type}`)
          .then((response) => {
            const { data } = response.data;
            this.form[type].start_date = data.start_date;
            this.form[type].end_date = data.end_date;
            this.form[type].status = data.status;
            // this.form[type].sequence = data.sequence;
            this.form[type].sectionStyle = data.style;
            this.form[type].image.url = data.image || '';
            this.form[type].title = data.title;
            this.form[type].title_en = data.title_en;
            this.form[type].description = data.description;
            this.form[type].description_en = data.description_en;
            this.form[type].item_type = data.item_type;
  
            if (data.items !== null && data.items.length > 0) {
              if (type === 'destination') {
                const domesticCity = data.items.filter(item => item.type === 'domestic');
                this.form[type].city_domestic = domesticCity.map(item => ({
                  value: item.id,
                  label: item.name,
                }));
                const internationalCity = data.items.filter(item => item.type === 'international');
                // if (internationalCity && internationalCity.length > 1) {
                  // this.form.destination.international.splice(0, 1);
                // }
                const newCountry = new Map();
                if (internationalCity && internationalCity.length) {
                  for (let i = 0; i < internationalCity.length; i += 1) {
                      const newCity = newCountry
                      .get(internationalCity[i].parent_id) ? newCountry
                      .get(internationalCity[i].parent_id).city_international : [];
                      newCountry.set(internationalCity[i].parent_id, {
                          country_international: [{
                              value: internationalCity[i].parent_id,
                              label: internationalCity[i].parent_name, 
                            }],
                          city_international: [...newCity,
                            {
                            value: internationalCity[i].id,
                            label: internationalCity[i].name, 
                          }],
                          });
                    }
                    const newDestination = [...newCountry].flat()
                    .filter(item => !(typeof item === 'number'));
                    this.form[type].international = newDestination;
                }
              } else {
                this.form[type].items = data.items.map(item => ({
                  value: item.id,
                  label: item.name,
                }));
              }
            }
            if (type !== 'category' && type !== 'destination') {
            if (data.destination_items !== null && data.destination_items.length > 0) {
                this.form[type].destination_items = data.destination_items.map(item => ({
                  destination_id: {
                    value: item.id,
                    label: item.name,
                  },
                  items: item.items.map(val => ({
                    value: val.id,
                    label: val.name,
                  })),
                }));
              }
              if (data.category_items !== null && data.category_items.length > 0
              && data.category_items[0].items !== null) {
                this.form[type].category_items = data.category_items.map(item => ({
                  category_id: {
                    value: item.id,
                    label: item.name,
                  },
                  items: item.items.map(val => ({
                    value: val.id,
                    label: val.name,
                  })),
                }));
              }
            }
            resolve();
          })
          .catch((error) => {
            console.log(`${type} error`, error);
  
            if (error.response) {
              this.error = error.response.data.errors;
              reject();
            }
          });
        }
      });
    },

    flattenData(data) {
      const result = [];

      data.forEach((parent) => {
        result.push({
          label: parent.name,
          value: parent.id,
        });

        if (parent.child && parent.child.length > 0) {
          parent.child.forEach((child) => {
            result.push({
              label: child.name,
              value: child.id,
            });

            if (this.tabDestination === 0 && child.child && child.child.length > 0) {
              child.child.forEach((grandChild) => {
                result.push({
                  label: grandChild.name,
                  value: grandChild.id,
                });
              });
            }
          });
        }
      });

      return flatten(result);
    },
    onClick(tabIndex) {
      this.tabDestination = tabIndex;
      this.fetchlist('destinations');
    },
    onSelectCountry(index, a) {
      if (a) {
        this.axios
        .get(`/destinations/${this.form.destination.international[index].country_international[0].value}`)
        .then((response) => {
          const cityData = response.data.data.child;
          this.lists.cities = cityData ? cityData.map(item => ({ 
            label: item.name, value: item.id })) : [];
        });
      } else {
        this.axios.get(`/destinations/${this.form.destination.international[index].country_international.value}`)
          .then((response) => {
            const cityData = response.data.data.child;
            this.form.destination.international[index].city_international = null;
            this.lists.cities = cityData ? cityData.map(item => ({ 
              label: item.name, value: item.id })) : [];
          });
      }
    },
    onSelectCategories(index, type, a) {
        this.form[type].item_type = this.form[type].item_type;
        this.form[type].items = [];
        let flaggingType;
        if (type === 'tour') {
          flaggingType = 'tour';
        } else {
          flaggingType = '';
        }
          this.axios
          .get(`/products?b2b_type=internal&flaging=${flaggingType}&category=${this.form[type].category_items[index].category_id.label}`)
          .then((response) => {
            const categoriesProd = response.data.data;
            if (!a) {
              this.form[type].category_items[index].items = null;
            }
            this.lists.categoriesProducts = categoriesProd ? categoriesProd.map(item => ({ 
                label: item.name, value: item.id })) : [];
          });
    },
    onSelectDomestic(index, type, a) {
      this.form[type].item_type = this.form[type].item_type;
      this.form[type].items = [];
      let flaggingType;
      if (type === 'tour') {
        flaggingType = 'tour';
      } else {
        flaggingType = '';
      }
        this.axios
        .get(`/products?b2b_type=internal&flaging=${flaggingType}&destination=${this.form[type].destination_items[index].destination_id.label}`)
        .then((response) => {
          const domesticProd = response.data.data;
          if (!a) {
            this.form[type].destination_items[index].items = null;
          }
          this.lists.domesticProducts = domesticProd ? domesticProd.map(item => ({ 
              label: item.name, value: item.id })) : [];
        });
    },
    onSelectperItem(type) {
      this.form[type].item_type = 'item';
    },
    onSelectInternational(index, type, a) {
      this.form[type].item_type = this.form[type].item_type;
      this.form[type].items = [];
      let flaggingType;
      if (type === 'tour') {
        flaggingType = 'tour';
      } else {
        flaggingType = '';
      }
        this.axios
          .get(`/products?b2b_type=internal&flaging=${flaggingType}&destination=${this.form[type].destination_items[index].destination_id.label}`)
          .then((response) => {
            const internationalProd = response.data.data;
            if (!a) {
              this.form[type].destination_items[index].items = null;
            }
            this.lists.internationalProducts = internationalProd ? internationalProd.map(item => ({ 
                label: item.name, value: item.id })) : [];
          });
    },
    onSelectDestination(index, type) {
      if (this.form[type].item_type !== 'category') {
        this.axios.get('/destinations', {
            params: {
              perpage: 1000,
            },
            headers: {
              'X-MA-Client': 'backend',
            },
          })
          .then((response) => {
            const { data } = response.data;

            if (!data) return;
              if (this.form[type].item_type === 'international' || this.tabDestination === 1) {
                this.tabDestination = 1;
                let dataChild = [];
                dataChild = data[1].child;
                if (type === 'destination') {
                  const result = [];
                  dataChild.forEach((parent) => {
                    result.push({
                      label: parent.name,
                      value: parent.id,
                    });
                  });
                  this.lists.destinations = result;
                } else {
                  this.lists.destinations = this.flattenData(dataChild);
                }
              } else {
                this.tabDestination = 0;
                let dataChild = [];
                dataChild = data[this.tabDestination].child;
  
                this.lists.destinations = this.flattenData(dataChild);
              }
          })
          .catch((error) => {
            if (error.response) {
               this.error = error.response.data.errors;
             }
          });
      }
    },
    changelist(type) {
      console.log(this.form[type].item_type);
      this.form[type].destination_items = [{
        destination_id: null,
        items: [],
      }];
      this.form[type].category_items = [{
        category_id: null,
        items: [],
      }];
      if (this.form[type].item_type !== 'category') {
        this.axios.get('/destinations', {
            params: {
              perpage: 1000,
            },
            headers: {
              'X-MA-Client': 'backend',
            },
          })
          .then((response) => {
            const { data } = response.data;

            if (!data) return;
              if (this.form[type].item_type === 'international') {
                this.tabDestination = 1;
                let dataChild = [];
                dataChild = data[1].child;
  
                this.lists.destinations = this.flattenData(dataChild);
              } else {
                this.tabDestination = 0;
                let dataChild = [];
                dataChild = data[this.tabDestination].child;
  
                this.lists.destinations = this.flattenData(dataChild);
              }
          })
          .catch((error) => {
            if (error.response) {
               this.error = error.response.data.errors;
             }
          });
      }
    },
    fetchlist(type) {
       this.error[type] = null;
       return new Promise((resolve, reject) => {
          this.axios.get(`/${type}`, {
              params: {
                perpage: 1000,
              },
              headers: {
                'X-MA-Client': 'backend',
              },
            })
            .then((response) => {
              const { data } = response.data;
  
              if (!data) return;
  
              if (type === 'destinations') {
                let dataChild = [];
                dataChild = data[this.tabDestination].child;
  
                this.lists[type] = this.flattenData(dataChild);
                // this.lists.cities = this.flattenData(dataGrandChild);
              } else if (type === 'categories') {
                this.lists[type] = data.map(item => ({
                  value: item.id,
                  label: item.name,
                }));
              }
              resolve();
            })
            .catch((error) => {
              if (error.response) {
                 this.error = error.response.data.errors;
                reject();
               }
            });
      });
    },

    async fetchlistProducts() {
      try {
        const response = await this.axios.get('/products-only');
        const products = response.data.data;
        if (products !== null) {
          products.forEach((item) => {
            this.lists.products.push({ 
              label: item.name, 
              value: item.id,
            });
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response) {
          this.error.product = error.response.data.errors;
        }
      }
    },

    async fetchlistProductsTour() {
      try {
        const response = await this.axios.get('/products-only?type_product=tour');
        const products = response.data.data;
        if (products !== null) {
          products.forEach((item) => {
            this.lists.productsTour.push({ 
              label: item.name, 
              value: item.id,
            });
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response) {
          this.error.product = error.response.data.errors;
        }
      }
    },

    async fetchlistHighlightSequence() {
      try {
        const response = await this.axios.get('/highlights/section');
        const dataSequence = response.data.data;
        if (dataSequence !== null) {
          dataSequence.forEach((item) => {
            this.lists.sequenceList.push({
              id: item.id,
              title: item.title,
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async fetchAll() {
      try {
        this.fetchlistProducts();
        await this.fetchlistProductsTour();
        await this.fetchlist('destinations');
        await this.fetchlist('categories');
        await this.fetchHighlight('favorite');
        await this.fetchHighlight('category');
        await this.fetchHighlight('destination');
        await this.fetchHighlight('trending');
        await this.fetchHighlight('tour');
        await this.fetchHighlight('campaign1');
        await this.fetchHighlight('campaign2');
        await this.fetchlistHighlightSequence();
      } catch (err) {
        console.log('Fetch highlights failed', err);
      }
      this.isLoading = false;
    },

    getTitleType(type) {
      let tabTitle = '';
      if (type === 'favorite') {
        tabTitle = 'Eksplorasi Terfavorit';
      } else if (type === 'category') {
        tabTitle = 'Category Populer';
      } else if (type === 'destination') {
        tabTitle = 'Destination Populer';
      } else if (type === 'trending') {
        tabTitle = 'Pilihan Bulan Ini';
      } else if (type === 'tour') {
        tabTitle = 'Rekomendasi Tour';
      } else if (type === 'campaign1') {
        tabTitle = 'Campaign 1';
      } else if (type === 'campaign2') {
        tabTitle = 'Campaign 2';
      } else if (type === 'sequence') {
        tabTitle = 'Sequence';
      }

      return tabTitle;
    },

    validateBeforeSubmit(type, items) {
      if (type === 'destination') {
        const cityDestination = this.form.destination.international.map(val => 
        val.city_international === null);
        const countryDestination = this.form.destination.international.map(val => 
        (val.country_international === null || val.country_international.length < 1));
        const checkNullCity = cityDestination.every(v => v === false);    
        const checkNullCountry = countryDestination.every(v => v === false);  

        if (!checkNullCity || !checkNullCountry) {
          this.$swal('Items required', 'Please select at least one City/Province on Domestic and International Destinations', 'warning');
          return false;
        }   
      }
      const tabTitle = this.getTitleType(type);
      if (type !== 'destination') {
        if (!this.form[type].start_date) {
          this.$swal('Start Date Required', `Please select Start Date on ${tabTitle}`, 'warning');
          return false;
        }
        if (!this.form[type].end_date) {
          this.$swal('End Date Required', `Please select End Date on ${tabTitle}`, 'warning');
          return false;
        }
        if (this.form[type].status < 0) {
          this.$swal('Status required', `Please fill Status on ${tabTitle}`, 'warning');
          return false;
        }
        if (!this.form[type].description) {
          this.$swal('Deskripsi required', `Please fill deskripsi on ${tabTitle}`, 'warning');
          return false;
        }

        if (!this.form[type].description_en) {
          this.$swal('Description required', `Please fill description on ${tabTitle}`, 'warning');
          return false;
        }
      }
      // if (type !== 'destination') {
      //   if (!this.form[type].sequence) {
      //     this.$swal('Sequence required', `Please fill Sequence on ${tabTitle}`, 'warning');
      //     return false;
      //   }
      // }
      if (type !== 'category' && type !== 'destination') {
        if (!this.form[type].sectionStyle) {
          this.$swal('Section Style required', `Please fill Section Style on ${tabTitle}`, 'warning');
          return false;
        }
      }

      
      if (!this.form[type].title) {
        this.$swal('Title required', `Please fill Title on ${tabTitle}`, 'warning');
        return false;
      }
      
      if (!this.form[type].title_en) {
        this.$swal('Title En required', `Please fill title on ${tabTitle}`, 'warning');
        return false;
      }
      if ((this.form[type].sectionStyle === 4)) {
        if (this.form[type].item_type === 'category') {
          const checkCategory = this.form[type].category_items
          .map(val => (val.category_id === null) === true);
          const checkNullCategory = checkCategory.every(v => v === false);
          if (!checkNullCategory) {
            this.$swal('Category required', 
            `Please select category on ${tabTitle}`, 'warning');
            return false;
          }
        }
        if (this.form[type].item_type === 'domestic'
        || this.form[type].item_type === 'international') {
          const checkDesinations = this.form[type].destination_items
          .map(val => (val.destination_id === null) === true);
          const checkNullDestination = checkDesinations.every(v => v === false);
          if (!checkNullDestination) {
            this.$swal('Destination required', 
            `Please select destination on ${tabTitle}`, 'warning');
            return false;
          }
        }
        const checkItems = items.map(val => (val.length < 1) === true);
        const checkNullItems = checkItems.every(v => v === false);
        if ((this.form[type].item_type === 'category' && !checkNullItems) || (this.form[type].item_type === 'domestic' && !checkNullItems) || (this.form[type].sectionStyle === 4 && this.form[type].item_type === 'international' && !checkNullItems)) {
          this.$swal('Items required', 
          `Please select at least one items on ${tabTitle}`, 'warning');
          return false;
        }
      }

      if (tabTitle === 'Category Populer' && items.length > 8) {
        this.$swal('Limited Input Category', 
        `Max of items selected is 8 on ${tabTitle}`, 'warning');
        return false;
      }
      
      if (items.length < 1 && tabTitle !== 'Destination Populer') {
        this.$swal('Items required', 
      `Please select at least one items on ${tabTitle}`, 'warning');
        return false;
      }

      if (items.length < 1 && tabTitle === 'Destination Populer') {
        this.$swal('Items required',
       'Please select at least one City/Province on Domestic and International Destinations',
       'warning');
        return false;
      }

      return true;
    },

    submit(type) {
      if (type === 'destination') {
        const items = this.form[type].city_domestic.map(item => item.value);
        const valid = this.validateBeforeSubmit(type, items);
        if (!valid) return;

        const internationalItem = this.form[type].international
        .flatMap(item => item.city_international.flatMap(val => val.value));
        const valids = this.validateBeforeSubmit(type, internationalItem);
        if (!valids) return;

        const joinItems = items.concat(internationalItem);
        const data = {
          start_date: this.parseTime(this.form[type].start_date, 'YYYY-MM-DD'),
          end_date: this.parseTime(this.form[type].end_date, 'YYYY-MM-DD'),
          status: this.form[type].status,
          // sequence: 10,
          title: this.form[type].title,
          title_en: this.form[type].title_en,
          description: this.form[type].description,
          description_en: this.form[type].description_en,
          items: JSON.stringify(joinItems),
        };
        this.axios.post(`highlights/${type}`, this.stringify(data))
          .then(() => {
            const tabTitle = this.getTitleType(type);
            this.$swal({
              title: 'Updated!',
              text: `${tabTitle} has been updated.`,
              type: 'success',
              timer: 2000,
            });
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data.errors;
            }
          });
      } else if (type === 'sequence') {
        const data = JSON.stringify(this.lists.sequenceList);
        this.axios.patch(`highlights/${type}`, data)
          .then(() => {
            const tabTitle = this.getTitleType(type);
            this.$swal({
              title: 'Updated!',
              text: `${tabTitle} has been updated.`,
              type: 'success',
              timer: 2000,
            });
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data.errors;
            }
          });
      } else {
        let items = [];
          if (this.form[type].item_type === 'category') {
            items = [];
            items = this.form[type].category_items &&
            this.form[type].category_items.length > 0 ?
            this.form[type].category_items.map(item =>
              ({
                category_id: item.category_id ? item.category_id.value : null,
                items: item.items && item.items.length > 0 ? item.items.map(val => val.value) : [],
            })) : [];
            const valid = this.validateBeforeSubmit(type, items);
            if (!valid) return;
          } else if (this.form[type].item_type === 'domestic' || this.form[type].item_type === 'international') {
            items = [];
            items = this.form[type].destination_items &&
            this.form[type].destination_items.length > 0 ?
            this.form[type].destination_items.map(item => 
            ({
              destination_id: item.destination_id ? item.destination_id.value : null,
              items: item.items && item.items.length > 0 ? item.items.map(val => val.value) : [],
            })) : [];
            const valid = this.validateBeforeSubmit(type, items);
            if (!valid) return;
          } else if (this.form[type].item_type === 'item') {
            items = [];
            items = this.form[type].items.map(item => item.value);
            const valid = this.validateBeforeSubmit(type, items);
            if (!valid) return;
          } else {
            items = [];
            items = this.form[type].items.map(item => item.value);
            const valid = this.validateBeforeSubmit(type, items);
            if (!valid) return;
          }
      
        if (type === 'category') {
          const data = {
              start_date: this.parseTime(this.form[type].start_date, 'YYYY-MM-DD'),
              end_date: this.parseTime(this.form[type].end_date, 'YYYY-MM-DD'),
              status: this.form[type].status,
              // sequence: this.form[type].sequence,
              title: this.form[type].title,
              title_en: this.form[type].title_en,
              description: this.form[type].description,
              description_en: this.form[type].description_en,
              items: JSON.stringify(items),
          };
          this.axios.post(`highlights/${type}`, this.stringify(data))
          .then(() => {
            const tabTitle = this.getTitleType(type);
            this.$swal({
              title: 'Updated!',
              text: `${tabTitle} has been updated.`,
              type: 'success',
              timer: 2000,
            });
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data.errors;
            }
          });
        } else if (type === 'campaign1' || type === 'campaign2') {
          if (this.form[type].sectionStyle < 4) {
            this.form[type].item_type = 'item';
          }
          const data = {
            start_date: this.parseTime(this.form[type].start_date, 'YYYY-MM-DD'),
            end_date: this.parseTime(this.form[type].end_date, 'YYYY-MM-DD'),
            status: this.form[type].status,
            // sequence: this.form[type].sequence,
            style: this.form[type].sectionStyle,
            image: this.form[type].image.id,
            item_type: this.form[type].item_type,
            category_items: this.form[type].item_type === 'category' ? JSON.stringify(items) : [],
            destination_items: this.form[type].item_type === 'domestic' || this.form[type].item_type === 'international' ? JSON.stringify(items) : [],
            type,
            title: this.form[type].title,
            title_en: this.form[type].title_en,
            description: this.form[type].description,
            description_en: this.form[type].description_en,
            items: this.form[type].item_type === 'domestic' || 
            this.form[type].item_type === 'international' 
            || this.form[type].item_type === 'category' 
            ? [] : JSON.stringify(items),
          };
          this.axios.post(`highlights/${type}`, this.stringify(data))
          .then(() => {
            const tabTitle = this.getTitleType(type);
            this.$swal({
              title: 'Updated!',
              text: `${tabTitle} has been updated.`,
              type: 'success',
              timer: 2000,
            });
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data.errors;
            }
          });
        } else {
          if (this.form[type].sectionStyle < 4) {
            this.form[type].item_type = 'item';
          }
          const data = {
            start_date: this.parseTime(this.form[type].start_date, 'YYYY-MM-DD'),
            end_date: this.parseTime(this.form[type].end_date, 'YYYY-MM-DD'),
            status: this.form[type].status,
            // sequence: this.form[type].sequence,
            image: this.form[type].image.id,
            style: this.form[type].sectionStyle,
            item_type: this.form[type].item_type,
            category_items: this.form[type].item_type === 'category' ? JSON.stringify(items) : [],
            destination_items: this.form[type].item_type === 'domestic' || this.form[type].item_type === 'international' ? JSON.stringify(items) : [],
            title: this.form[type].title,
            title_en: this.form[type].title_en,
            description: this.form[type].description,
            description_en: this.form[type].description_en,
            items: this.form[type].item_type === 'domestic' || 
            this.form[type].item_type === 'international' 
            || this.form[type].item_type === 'category' 
            ? [] : JSON.stringify(items),
          };
          this.axios.post(`highlights/${type}`, this.stringify(data))
          .then(() => {
            const tabTitle = this.getTitleType(type);
            this.$swal({
              title: 'Updated!',
              text: `${tabTitle} has been updated.`,
              type: 'success',
              timer: 2000,
            });
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data.errors;
            }
          });
        }
      }
    },

    addItem(type, itemType) {
      if (type === 'international') {
        this.form.destination.international.push({
          country_international: [],
          city_international: [],
        });
      }
        if (itemType === 'categories') {
          this.form[type].category_items.push({
            category_id: null,
            items: [],
          });
        } else if (itemType === 'destination') {
          this.form[type].destination_items.push({
            destination_id: null,
            items: [],
          });
        }
    },
    removeItem(item, object, itemIndex) {
      this.$swal({
        title: 'Delete Item',
        text: 'Are you sure to delete this item?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#666',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          if (object === 'international') {
            this.form.destination.international.splice(itemIndex, 1);
          }
          if (item === 'categories') {
            this.form[object].category_items.splice(itemIndex, 1);
          }
          if (item === 'destination') {
            this.form[object].destination_items.splice(itemIndex, 1);
          }
        }
      });
    },
  },

  created() {
    this.fetchAll();
  },
};
</script>

<style scoped>
  .v-tabs-content {
    display: block;
    margin: 2rem 0;
  }
  .imageSectionStyle {
    width: 100%;
  }
  .styleSection {
    border: 1px solid black;
    display: flex;
    flex-flow: wrap;
  }
  .imageSection {
    height: 300px;
  }
  .styleItems {
    border: 1px solid black;
    padding: 15px 30px 0 0;
  }
  .styleSingleItems {
    padding: 0;
  }
  .listSequence {
    margin: 10px;
  }
  .flip-list-move {
  transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .list-group {
    min-height: 20px;
  }
  .list-group-item {
    cursor: grab;
  }
  .list-group-item:active {
    cursor: grabbing;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/highlights/Form.vue